import type { CookieOptions } from '../_types';

export function setCookie(
  name: string,
  value: string,
  options: CookieOptions = {},
): void {
  const {
    expires,
    maxAge,
    path = '/',
    domain,
    secure = false,
    sameSite = 'lax',
  } = options;

  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  if (expires) cookieString += `; expires=${expires.toUTCString()}`;
  if (maxAge) cookieString += `; max-age=${maxAge}`;

  cookieString += `; path=${path}`;

  if (domain) cookieString += `; domain=${domain}`;
  if (secure) cookieString += '; secure';

  cookieString += `; samesite=${sameSite}`;
  document.cookie = cookieString;
}

export function getCookie(name: string): string | null {
  const nameEQ = encodeURIComponent(name) + '=';
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
    if (cookie.indexOf(nameEQ) === 0)
      return decodeURIComponent(cookie.substring(nameEQ.length));
  }

  return null;
}

export function deleteCookie(name: string, path: string = '/'): void {
  setCookie(name, '', {
    expires: new Date(0),
    path,
  });
}

export function getAuthToken(): string | null {
  return getCookie('token');
}

export function setAuthToken(token: string, maxAge: number = 86400): void {
  setCookie('token', token, {
    maxAge,
    path: '/',
    sameSite: 'lax',
    secure: window.location.protocol === 'https:',
  });
}

export function deleteAuthToken(): void {
  deleteCookie('token');
}

export function isAuthenticated(): boolean {
  const token = getAuthToken();
  return token !== null && token.length > 0;
}
